module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 2